import React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';

export function getTestIdByDisplayName(displayName) {
  return displayName && displayName.replace('Icon', '-icon').toLowerCase();
}

const Icon = (path, customViewBox, displayName) => {
  const BaseIcon = (props) => {
    const {
      className, inverted, selected, small, viewBox, ...others
    } = props;
    const classes = classname(
      'icon',
      {
        'icon--inverted': inverted,
        'icon--small': small,
        'icon--selected': selected,
      },
      className,
    );

    return (
      <svg
        className={classes}
        viewBox={viewBox || customViewBox || '0 0 50 50'}
        data-testid={getTestIdByDisplayName(displayName)}
        {...others}
      >
        {path}
      </svg>
    );
  };

  BaseIcon.propTypes = {
    /** Classi css personalizzate da aggiungere al componente */
    className: PropTypes.string,
    /** Inverte i colori dell'icona */
    inverted: PropTypes.bool,
    /** Applica lo stile selected */
    selected: PropTypes.bool,
    /** Riduce la dimensione dell'icona */
    small: PropTypes.bool,
    /** Viewbox personalizzato */
    viewBox: PropTypes.string,
  };

  BaseIcon.defaultProps = {
    className: '',
    inverted: false,
    selected: false,
    small: false,
    viewBox: '',
  };

  BaseIcon.displayName = displayName;

  return BaseIcon;
};

export default Icon;
